import React from 'react';
import { ArrowLeft } from '@procore/core-icons';
import { Box } from '@procore/core-react';

export const ArrowPrev = () => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="center"
    style={{ height: '100%' }}
  >
    <ArrowLeft data-testid="arrow-left" size="md" style={{ color: 'black' }} />
  </Box>
);
